// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2U0-b","log":"ModalInventoryLogs_log__2xgWI","date":"ModalInventoryLogs_date__MIAAt","userName":"ModalInventoryLogs_userName__3fmrL"};